<div>
    <button (click)="open()" class="slant-button">{{menuData.categoryName | characterPipe}}</button>

</div>
